import axios from 'axios';
import { Toast } from '../service/alert';
import { getAccountInfo } from './account';
import axiosRetry from 'axios-retry';

const client = axios.create();
axiosRetry(client, {
    retries: 3, retryDelay: (retryCount: number) => {
        return Math.pow(2, retryCount) * 300;
    }
});

client.interceptors.request.use(config => {
    const accountInfo = getAccountInfo()

    if (accountInfo) {
        config.headers.Authorization = `Bearer ${accountInfo?.loginSession?.mToken}`;
    }
    return config;
});

client.interceptors.response.use(res => {
    return res
}, err => {
    if (err?.response?.data?.error?.statusCode === 400) {
        const detail = err?.response?.data?.error?.details
        const { code, message, vi } = detail && detail[0] || {}

        if (vi?.title) {
            Toast.fire({
                icon: 'error',
                title: vi?.title,
                text: vi?.message || ''
            })
        } else {
            Toast.fire({
                icon: 'error',
                title: 'Có lỗi xảy ra, vui lòng thử lại sau',
            })
        }
        return Promise.reject(err)
    }

    return Promise.reject(err)
})

export default client